"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _phoneHint = _interopRequireDefault(require("./phoneHint"));

var _jsxRuntime = require("react/jsx-runtime");

var SelectHint = function SelectHint(_ref) {
  var hintComponent = _ref.hintComponent;

  switch (hintComponent) {
    case 'phoneHint':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_phoneHint.default, {}, hintComponent);

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
};

var _default = SelectHint;
exports.default = _default;